export const handleUrl = (url) => {
  if (!url.includes('http')) {
    url = 'https://' + url
  }
  return url
}
